<div class="preloader" [ngClass]="windowLoad ? 'd-none':''">
    <!-- <img src="assets/img/logo.png" class="preloader-image" width="200" alt="preloader"/> -->
    <img src="assets/img/logo-zcaler.png" class="img-fluid" alt="Zscaler logo" style="margin-right:10px; width: 130px;">
   <p class=" lead text-white " >  ThreatLabz</p>
</div>